import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PaginatedContextData, PaginatedData } from 'src/app/shared/contexts/asyncData';

import { getDmProfileRedesignConfig } from '../pageData/utils/profileRedesignConfig';

import { DecisionMakerResponses } from './api.graphql';
import type { DecisionMakerResponsesQuery, DecisionMakerResponsesQueryVariables } from './api.graphql';
import type { DecisionMakerResponsesItem } from './types';

type DecisionMakerResponsesApiData = PaginatedData<
	DecisionMakerResponsesItem,
	{
		totalCount: number;
		totalCountLocalized: string;
	}
>;

export type DecisionMakerResponsesData = PaginatedContextData<DecisionMakerResponsesApiData>;

async function getData({
	utilityContext,
	slug,
	cursor,
	numResponsesToFetch,
}: {
	utilityContext: UtilityContext;
	slug: string;
	cursor?: string;
	numResponsesToFetch?: number;
}): Promise<DecisionMakerResponsesApiData> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<DecisionMakerResponsesQuery, DecisionMakerResponsesQueryVariables>({
		query: DecisionMakerResponses,
		variables: { cursor: cursor ?? null, slug, numResponsesToFetch: numResponsesToFetch || 10 },
		rejectOnError: true,
	});

	if (!data.decisionMaker) throw new NotFoundError();

	return {
		items: data.decisionMaker.responsesConnection.nodes,
		cursor: data.decisionMaker.responsesConnection.pageInfo.endCursor,
		hasNextPage: data.decisionMaker.responsesConnection.pageInfo.hasNextPage,
		totalCount: data.decisionMaker.responsesConnection.totalCount,
		totalCountLocalized: data.decisionMaker.responsesConnection.totalCountLocalized,
	};
}
export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	const dmProfileRedesignConfig = await getDmProfileRedesignConfig(utilityContext);
	const numResponsesToFetch = dmProfileRedesignConfig.responseList ? 3 : 10;

	return getData({ utilityContext, slug, numResponsesToFetch });
}

export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData({ utilityContext, slug, cursor });
}
